import { operatorApiFetch } from './apiService';

export const contactAddressService = {
  // 獲取地址列表 (Search)
  getList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.merchant_id) queryParams.append('merchant_id', params.merchant_id);

    const response = await operatorApiFetch(`contact_addresses?${queryParams.toString()}`);
    return response.json();
  },

  fetchAddresses: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.merchant_id) queryParams.append('merchant_id', params.merchant_id);

    const response = await operatorApiFetch(`contact_addresses?${queryParams.toString()}`);
    return response.json();
  },

  getRecords: async (params) => {
    const response = await operatorApiFetch('contact_addresses/get_records', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },

  getIds: async (params) => {
    const response = await operatorApiFetch('contact_addresses/get_ids', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },

  get: async (id) => {
    const response = await operatorApiFetch(`contact_addresses/${id}`);
    return response.json();
  },

  create: async (data, merchantId) => {
    const body = { contact_address: data };
    if (merchantId) {
      body.merchant_id = merchantId;
    }
    const response = await operatorApiFetch('contact_addresses', {
      method: 'POST',
      body: JSON.stringify(body)
    });
    return response.json();
  },

  update: async (id, data) => {
    const response = await operatorApiFetch(`contact_addresses/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ contact_address: data })
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`contact_addresses/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 匯出
  export: async (ids) => {
    const res = await operatorApiFetch('contact_addresses/export', {
      method: 'POST',
      body: { ids }
    });
    return res.json();
  },

  // 匯入
  import: async (formData) => {
    const res = await operatorApiFetch('contact_addresses/import', {
      method: 'POST',
      body: formData
    });
    return res.json();
  },

  // 下載匯入模板
  downloadImportTemplate: async (locale, merchantId) => {
    const body = { type: 'contact_address', locale };
    if (merchantId) {
      body.merchant_id = merchantId;
    }
    return operatorApiFetch('import_templates/download', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }
};
